module.exports = __webpack_public_path__ + "static/media/bg-hero-01.6ca966b5.png";